import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const admins = async (data: AdminsReqT) => {
  const { pageParam, name } = data;

  const qs = `?page=${pageParam ?? 1}&name=${name ?? ""}`;

  return axios.get(Routes.ADMINS + qs);
};

export const useAdmins = (params: AdminsReqT) => {
  const { name } = params;

  return useInfiniteQuery({
    queryKey: [Keys.ADMINS_QRY, name],
    queryFn: ({ pageParam = 1 }) => admins({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
